/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Tek kaynak qubepro-core; uydu projelere resmi sync ile dağıtılır.
 */

export interface DataTableColumnWidth {
    width?: string;
    /** Minimum usable width in CSS pixels, including header controls. */
    minWidth?: number;
}

const DEFAULT_COLUMN_MIN_WIDTH = 160;
const positive = (value: unknown): value is number => typeof value === 'number' && Number.isFinite(value) && value > 0;
const pixels = (value?: string) => value?.trim().match(/^(\d+(?:\.\d+)?)px$/i);

export function resolveDataTableColumnWidth(column: DataTableColumnWidth, saved?: number) {
    const declaredPixels = pixels(column.width);
    const declared = declaredPixels ? Number(declaredPixels[1]) : undefined;
    // Explicit compact ID/icon columns keep their existing design. Unspecified
    // columns receive a usable default instead of sharing an arbitrary 800px.
    const minWidth = positive(column.minWidth) ? column.minWidth
        : positive(declared) ? Math.min(DEFAULT_COLUMN_MIN_WIDTH, declared) : DEFAULT_COLUMN_MIN_WIDTH;
    const pixelWidth = positive(saved) ? Math.max(saved, minWidth)
        : positive(declared) ? Math.max(declared, minWidth) : minWidth;
    const width = positive(saved) || declaredPixels || !column.width
        ? `${pixelWidth}px` : column.width;
    const percent = width.trim().match(/^(\d+(?:\.\d+)?)%$/);
    return { width, minWidth, pixelWidth, percentageMinimum: percent && Number(percent[1]) > 0 ? minWidth * 100 / Number(percent[1]) : 0 };
}

export function dataTableMinimumWidth(widths: ReturnType<typeof resolveDataTableColumnWidth>[], selection = false) {
    return Math.ceil(Math.max(
        widths.reduce((total, column) => total + column.pixelWidth, selection ? 52 : 0),
        ...widths.map(column => column.percentageMinimum),
    ));
}
